import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import ReactHtmlParser from 'react-html-parser'
import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.js'
import moment from 'moment'
import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'
import { YMaps, Map, Placemark, ObjectManager, ZoomControl, Circle } from 'react-yandex-maps'
import YandexShare from 'react-yandex-share'

import platform from 'platform'

import packageJson from './../package.json'
import MapDialog from './components/MapDialog'
import Runman from './components/Runman'
import Waves from './components/Waves'
import Poll from './components/Poll'

import { ClearRequests, Ping } from './components/NetworkHelpers'
import { ConnectionTypeString } from './components/Helpers'

class Megabitus extends Component {

	ymaps = null;
	map = null;
	radius = 10000;
	defaultCenter;
	my = null;

	constructor(props) {
		super(props);

		var deviceID = Cookies.get('deviceID')
		if (!deviceID) {
			deviceID = uuidv4()
			Cookies.set('deviceID', deviceID, { expires: 30 * 6 }) // 6 months
		}

		this.state = {
			session: {
				testId: false,
				versionApp: packageJson.version,
				OS: platform.os,
				deviceID: deviceID,
				deviceBrand: platform.name,
				deviceModel: platform.version,
				userAgent: navigator.userAgent,
			},
			testIdTemp: false,
			loading: true,
			speedometerValue: 0,
			progress: {
				visible: false,
			},
			testStatus: 0,
			buttonDisabled: true,
			showIndicators: false,
			showStart: true,
			showRestart: false,
			server: {},
			showToast: false,
			ping: "—",
			jitter: "—",
			losses: "—",
			download: "—",
			upload: "—",
			downloadState: false,
			uploadState: false,
			showMapDialog: false,
			GPSEnd: false,
			mapCenter: false,
			center: false,
			ymapsLoaded: false,
			features: [],
			speedtests: [],
			my: false,
			addressCardOpened: false,
			detailData: false,
			clusterData: false,
			showDetailPanel: false,
			showClusterPanel: false,
			loadingDetail: true,
			detail: [],
			stack: false,
			showMy: false,
			address: "",
			poll: false,
			pollTimeout: 2000,
		}

		this.handleClick = this.handleClick.bind(this)
		this.handleCloseMapDialog = this.handleCloseMapDialog.bind(this)
		this.handleOpenMap = this.handleOpenMap.bind(this)
		this.handleRestartMapDialog = this.handleRestartMapDialog.bind(this)
		this.handleCenter = this.handleCenter.bind(this)
		this.handleCloseAddressCard = this.handleCloseAddressCard.bind(this)
		this.handleBack = this.handleBack.bind(this)
	}

	handleClick() {
		if(this.state.testStatus === 0) {
			var bwmeter = document.querySelector('#bwmeter');
			bwmeter.style.height = '';

			window.scrollTo({ top: 0, behavior: 'smooth' });
			this.reset();
			this.setState({
				testStatus: 1,
				showIndicators: true,
				showStart: false,
				showRestart: false,
				session: {
					...this.state.session,
					startTime: moment().format("YYYY-MM-DD HH:mm:ss")
				}
			});

			this.gps();

			this.ping();
		}
	}

	handleCloseMapDialog() {
		this.setState({
			showMapDialog: false,
			pollTimeout: 2000,
		});
	}

	handleCloseAddressCard() {
		this.setState({
			addressCardOpened: false,
			detailData: false,
			clusterData: false,
		});
	}

	handleOpenMap(id, poll) {
		this.setState({
			showMapDialog: false,
			poll: poll,
			pollTimeout: 2000,
		})

		$('#bwmeter-map-tab').tab('show')
	}

	handleRestartMapDialog() {
		this.setState({ showMapDialog: false });
		this.handleClick();
	}

	ping() {
		var pings = 5,
			pingDetails = [],
			i = 0,
			pingT = -1,
			jitter = 0.0,
			losses = 0.0,
			prevDelta = 0;

		var doPing = function(url, speedometer) {
			if (i++ === pings) {
				if (pingT === -1) {
					speedometer.showError("Ping error")
				} else {
					speedometer.setState({
						ping: pingT,
						jitter: jitter.toFixed(2),
						downloadState: true,
						progress: {
							visible: true,
						},
						session: {
							...speedometer.state.session,
							jitter: jitter,
							ping: pingT,
							pingDetails: pingDetails.toString(),
						},
					});

					speedometer.download();
				}
			} else {
				Ping(url).then(function(delta) {
					console.log('Ping time was ' + String(delta) + ' ms');

					pingDetails.push(delta);

					if ((delta > 0 && delta < pingT) || pingT === -1) pingT = delta;

					if (i > 2) {
						if (delta < 1) delta = prevDelta;
						if (delta < 1) delta = 1;

						var instjitter = Math.abs(delta - prevDelta);
						if (i === 3) jitter = instjitter;
						else jitter = instjitter > jitter ? jitter * 0.3 + instjitter * 0.7 : jitter * 0.8 + instjitter * 0.2; // update jitter, weighted average. spikes in ping values are given more weight.
					}
					prevDelta = delta;

					speedometer.setState({
						ping: delta,
						jitter: jitter.toFixed(2),
						losses: losses.toFixed(2),
					});

					var bwmeter = document.querySelector('#bwmeter');
					bwmeter.style.height = bwmeter.offsetHeight+'px';

					doPing(url, speedometer);
				}).catch(function(err) {
					console.log('Ping time was -1 ms');

					pingDetails.push(-1);

					speedometer.setState({
						jitter: jitter.toFixed(2),
						losses: losses.toFixed(2),
					});

					doPing(url, speedometer);
				});
			}
		}

		doPing(this.state.server.url, this);
	}

	losses() {
		var losses = 0;
		var lossesDetails = [];

		var lossesPing = function(url, speedometer) {
			if (speedometer.state.uploadState) {
				Ping(url).then(function(delta) {
					// console.log('Ping time was ' + String(delta) + ' ms');

					lossesDetails.push(delta);

					var count = 0;
					for(var i = 0; i < lossesDetails.length; ++i) {
						if(lossesDetails[i] === -1)
							count++;
					}

					losses = Math.round(count/lossesDetails.length*100*100)/100;

					speedometer.setState({
						losses: losses.toFixed(2)
					});

					lossesPing(url, speedometer);
				}).catch(function(err) {
					lossesDetails.push(-1);

					var count = 0;
					for(var i = 0; i < lossesDetails.length; ++i) {
						if(lossesDetails[i] === -1)
							count++;
					}

					losses = Math.round(count/lossesDetails.length*100*100)/100;

					speedometer.setState({
						losses: losses.toFixed(2)
					});

					lossesPing(url, speedometer);
				});
			} else {
				speedometer.setState({
					session: {
						...speedometer.state.session,
						losses: losses,
						lossesDetails: lossesDetails.toString(),
					},
				});

				speedometer.result();
			}
		};

		lossesPing(this.state.server.url, this);
	}

	download() {
		var speedometer = this;

		var streams = 6,
			streamDelay = 300,
			chunkSize = 100,
			totLoaded = 0.0,
			graceTime = 1.5,
			ignoreErrors = false,
			failed = false,
			downloadDetails = [];

		var xhr = [];

		var testStream = function(i, delay, speedometer) {
			setTimeout(() => {
				if (!speedometer.state.downloadState) return; // delayed stream ended up starting after the end of the download test

				// console.log("download stream started " + i + " " + delay);

				var prevLoaded = 0; // number of bytes loaded last time onprogress was called
				var x = new XMLHttpRequest();
				xhr[i] = x;
				xhr[i].onprogress = function(event) {
					// console.log("download stream progress event " + i + " " + event.loaded);

					if (!speedometer.state.downloadState) {
						try {
							x.abort();
						} catch (e) {}
					}

					var loadDiff = event.loaded <= 0 ? 0 : event.loaded - prevLoaded;
					if (isNaN(loadDiff) || !isFinite(loadDiff) || loadDiff < 0) return;
					totLoaded += loadDiff;
					prevLoaded = event.loaded;
				};

				xhr[i].onload = function() {
					console.log("download stream finished " + i);
					try {
						xhr[i].abort();
					} catch (e) {}
					testStream(i, 0, speedometer);
				};

				xhr[i].onerror = function() {
					console.log("download stream failed " + i);
					if (!ignoreErrors) failed = true; //abort
					try {
						xhr[i].abort();
					} catch (e) {}
					delete xhr[i];
					if (ignoreErrors) testStream(i, 0, speedometer); //restart stream
				};

				try {
					xhr[i].responseType = "arraybuffer";
				} catch (e) {}

				xhr[i].open("GET", speedometer.state.server.garbage + "?cors=true&r=" + Math.random() + "&ckSize=" + chunkSize, true);
				xhr[i].send();
			}, 1 + delay);
		};

		// open streams
		for (var i = 0; i < streams; i++) {
			testStream(i, streamDelay * i, speedometer);
		}

		var startT = new Date().getTime(),
			bonusT = 0,
			graceTimeDone = false,
			timeAuto = true,
			timeMax = 15,
			speedometerValue = 0;

		// update status
		var interval = setInterval(() => {
			// console.log("download: " + speedometerValue + (graceTimeDone ? "" : " (in grace time)"));
			var t = new Date().getTime() - startT;

			if (graceTimeDone) {
				speedometer.setState({
					download: speedometerValue,
					speedometerValue: parseFloat(speedometerValue),
				});

				downloadDetails.push(parseFloat(speedometerValue));
			}

			// if (t < 200) return;
			if (!graceTimeDone) {
				if (t > 1000 * graceTime) {
					if (totLoaded > 0) {
						// if the connection is so slow that we didn't get a single chunk yet, do not reset
						startT = new Date().getTime();
						bonusT = 0;
						totLoaded = 0.0;
					}
					graceTimeDone = true;
				}
			} else {
				var speed = totLoaded / (t / 1000.0);
				if (timeAuto) {
					//decide how much to shorten the test. Every 200ms, the test is shortened by the bonusT calculated here
					var bonus = (6.4 * speed) / 100000;
					bonusT += bonus > 100 ? 100 : bonus;
				}

				// Overhead compensation
				var overheadCompensation = 6;			// 6% max
				var overheadCompensationLimit = 100;	// 100 Mbps
				var speedInBits = speed * 8;
				if (speedInBits > 0) {
					var compensationRatio = overheadCompensationLimit / (speedInBits / 1000000);
					compensationRatio = compensationRatio > 1 ? compensationRatio : 0;
					overheadCompensation = 1 + compensationRatio / 100;
				//	console.log(speedInBits / 1000000, (speedInBits * overheadCompensation - speedInBits) / 1000000, overheadCompensation);
				}

				// Update speedometer
				speedometerValue = ((speedInBits * overheadCompensation) / 1000000).toFixed(2);
				if ((t + bonusT) / 1000.0 > timeMax || failed) {
					// test is over, stop streams and timer
					if (failed || isNaN(speedometerValue)) {
						speedometerValue = 0;
					//	return true;
					}
					xhr = ClearRequests(xhr);
					clearInterval(interval);

					downloadDetails.push(parseFloat(speedometerValue));
					downloadDetails.shift();

					const n = downloadDetails.length;
					const mean = downloadDetails.reduce((a,b) => a+b)/n;
					const s = Math.sqrt(downloadDetails.map(x => Math.pow(x-mean,2)).reduce((a,b) => a+b)/n);

					var filteredArray = [];
					downloadDetails.forEach(function(value) {
						if (value >= (mean - s) && value <= (mean + s))
							filteredArray.push(value);
					});
					speedometerValue = (filteredArray.reduce((a,b) => a+b)/filteredArray.length).toFixed(2);

					speedometer.setState({
						download: speedometerValue,
						speedometerValue: 0,
						downloadState: false,
						uploadState: true,
						session: {
							...speedometer.state.session,
							download: parseFloat(speedometerValue),
							downloadDetails: downloadDetails.toString(),
						},
					});

					console.log("download test: " + speedometerValue + ", took " + (new Date().getTime() - startT) + "ms");

					speedometer.upload();
				}
			}
		}, 200);
	}

	upload() {
		var speedometer = this;
		speedometer.losses();

		var blobMegabytes = 20,
			req = [],
			reqsmall = [];

		if (/Chrome.(\d+)/i.test(navigator.userAgent) &&
			/Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)) {
			//cheap af
			//Chrome mobile introduced a limitation somewhere around version 65, we have to limit XHR upload size to 4 megabytes
			blobMegabytes = 2;
		}

		// garbage data for upload test
		var r = new ArrayBuffer(1048576);
		var maxInt = Math.pow(2, 32) - 1;
		try {
			r = new Uint32Array(r);
			for (var i = 0; i < r.length; i++) r[i] = Math.random() * maxInt;
		} catch (e) {}
		for (var j = 0; j < blobMegabytes; j++) req.push(r);
		req = new Blob(req);

		r = new ArrayBuffer(262144);
		try {
			r = new Uint32Array(r);
			for (var k = 0; k < r.length; k++) r[k] = Math.random() * maxInt;
		} catch (e) {}
		reqsmall.push(r);
		reqsmall = new Blob(reqsmall);

		var streams = 3,
			streamDelay = 300,
			totLoaded = 0.0,
			startT = new Date().getTime(),
			bonusT = 0,
			graceTime = 3,
			graceTimeDone = false,
			timeAuto = true,
			ignoreErrors = false,
			failed = false,
			speedometerValue = 0,
			timeMax = 15,
			forceIE11Workaround = false,
			uploadDetails = [];

		if (/Edge.(\d+\.\d+)/i.test(navigator.userAgent) ||
			/PlayStation 4.(\d+\.\d+)/i.test(navigator.userAgent) ||
			/^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent)) {
			//Edge 15 introduced a bug that causes onprogress events to not get fired, we have to use the "small chunks" workaround that reduces accuracy
			forceIE11Workaround = true;
		}

		var xhr = [];

		var testStream = function(i, delay, speedometer) {
			setTimeout(() => {
				if (!speedometer.state.uploadState) return; // delayed stream ended up starting after the end of the upload test

				console.log("upload stream started " + i + " " + delay);

				var prevLoaded = 0; // number of bytes transmitted last time onprogress was called
				var x = new XMLHttpRequest();
				xhr[i] = x;

				var ie11workaround = true;
				if (!forceIE11Workaround) {
					if (typeof xhr[i].upload.onprogress !== 'undefined')
						ie11workaround = false;
				}

				if (ie11workaround) {
					// IE11 workarond: xhr.upload does not work properly, therefore we send a bunch of small 256k requests and use the onload event as progress. This is not precise, especially on fast connections
					xhr[i].onload = xhr[i].onerror = function() {
						totLoaded += reqsmall.size;
						testStream(i, 0, speedometer);
					};
				} else {
					xhr[i].upload.onprogress = function(event) {
						if (!speedometer.state.uploadState) {
							try {
								x.abort();
							} catch (e) {}
						}

						var loadDiff = event.loaded <= 0 ? 0 : event.loaded - prevLoaded;
						if (isNaN(loadDiff) || !isFinite(loadDiff) || loadDiff < 0) return; // just in case
						totLoaded += loadDiff;
						prevLoaded = event.loaded;
					};

					xhr[i].upload.onload = function() {
						// console.log("upload stream finished " + i);
						testStream(i, 0, speedometer);
					};

					xhr[i].upload.onerror = function() {
						// console.log("upload stream failed " + i);
						if (!ignoreErrors) failed = true; //abort
						try {
							xhr[i].abort();
						} catch (e) {}
						delete xhr[i];
						if (ignoreErrors) testStream(i, 0, speedometer); //restart stream
					};
				}

				xhr[i].open("POST", speedometer.state.server.url + "?cors=true&r=" + Math.random(), true); // random string to prevent caching
				try {
					xhr[i].setRequestHeader("Content-Encoding", "identity"); // disable compression (some browsers may refuse it, but data is incompressible anyway)
				} catch (e) {}

				xhr[i].send(ie11workaround ? reqsmall : req);
			}, 1);
		};

		// open streams
		for (var l = 0; l < streams; l++) {
			testStream(l, streamDelay * l, speedometer);
		}

		// update status
		var interval = setInterval(() => {
			// console.log("upload: " + speedometerValue + (graceTimeDone ? "" : " (in grace time)"));

			var t = new Date().getTime() - startT;

			if (graceTimeDone) {
				speedometer.setState({
					upload: speedometerValue,
					speedometerValue: parseFloat(speedometerValue),
				});

				uploadDetails.push(parseFloat(speedometerValue));
			}

			// if (t < 200) return;
			if (!graceTimeDone) {
				if (t > 1000 * graceTime) {
					if (totLoaded > 0) {
						startT = new Date().getTime();
						bonusT = 0;
						totLoaded = 0.0;
					}
					graceTimeDone = true;
				}
			} else {
				var speed = totLoaded / (t / 1000.0);
				if (timeAuto) {
					//decide how much to shorten the test. Every 200ms, the test is shortened by the bonusT calculated here
					var bonus = (6.4 * speed) / 100000;
					bonusT += bonus > 100 ? 100 : bonus;
				}

				// Overhead compensation
				var overheadCompensation = 6;			// 6% max
				var overheadCompensationLimit = 100;	// 100 Mbps
				var speedInBits = speed * 8;
				if (speedInBits > 0) {
					var compensationRatio = overheadCompensationLimit / (speedInBits / 1000000);
					compensationRatio = compensationRatio > 1 ? compensationRatio : 0;
					overheadCompensation = 1 + compensationRatio / 100;
				//	console.log(speedInBits / 1000000, (speedInBits * overheadCompensation - speedInBits) / 1000000, overheadCompensation);
				}

				// Update speedometer
				speedometerValue = ((speedInBits * overheadCompensation) / 1000000).toFixed(2);
				if ((t + bonusT) / 1000.0 > timeMax || failed) {
					// test is over, stop streams and timer
					if (failed || isNaN(speedometerValue)) {
						speedometerValue = 0;
					}
					xhr = ClearRequests(xhr);
					clearInterval(interval);

					uploadDetails.push(parseFloat(speedometerValue));
					uploadDetails.shift();

					const n = uploadDetails.length;
					const mean = uploadDetails.reduce((a,b) => a+b)/n;
					const s = Math.sqrt(uploadDetails.map(x => Math.pow(x-mean,2)).reduce((a,b) => a+b)/n);

					var filteredArray = [];
					uploadDetails.forEach(function(value) {
						if (value >= (mean - s) && value <= (mean + s))
							filteredArray.push(value);
					});
					speedometerValue = (filteredArray.reduce((a,b) => a+b)/filteredArray.length).toFixed(2);

					speedometer.setState({
						upload: speedometerValue,
						speedometerValue: 0,
						uploadState: false,
						testStatus: 0,
						progress: {
							visible: false,
						},
						session: {
							...speedometer.state.session,
							upload: parseFloat(speedometerValue),
							uploadDetails: uploadDetails.toString(),
						},
					});

					console.log("upload test: " + speedometerValue + ", took " + (new Date().getTime() - startT) + "ms");
				}
			}
		}, 200);
	}

	result() {
		var bwmeter = document.querySelector('#bwmeter')
		bwmeter.style.height = ''

		fetch("https://api.megabitus.com/v1/result", {
			method: "POST",
			body: JSON.stringify(this.state.session)
		})
			.then(res => res.json())
			.then(result => {
				if (result.success) {
					this.setState(state => {
						return {
							...state,
							session: {
								...state.session,
								testId: result.data.testId,
							},
							testIdTemp: result.data.session.TestID,
							showMapDialog: true,
							showRestart: true,
							poll: result.data.poll ? result.data.poll : false,
							pollTimeout: 30*1000,
						}
					});

					var bwmeter = document.querySelector('#bwmeter');
					bwmeter.style.height = bwmeter.offsetHeight+'px';
				} else this.showError(result)
			}, error => this.showError(error));
	}

	gps() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				position => {
					console.log('Position', position.coords);
					this.defaultCenter = [position.coords.latitude, position.coords.longitude];
					this.setState({
						session: {
							...this.state.session,
							locationGPS: 1,
							locationAccuracy: position.coords.accuracy,
							locationLatitude: position.coords.latitude,
							locationLongitude: position.coords.longitude,
						},
						GPSEnd: true,
						center: [position.coords.latitude, position.coords.longitude],
						mapCenter: [position.coords.latitude, position.coords.longitude],
					});
				},
				error => {
					console.log(error)
					this.setState({GPSEnd: true});
				}
			);
		} else {
			this.setState({GPSEnd: true});
		}
	}

	servers() {
		fetch("https://api.megabitus.com/v1/servers", { method: "GET" })
			.then(res => res.json())
			.then(
				(result) => {
					if (result.success) {
						this.setState({
							session: {
								...this.state.session,
								testId: result.data.testId,
								serverID: result.data.servers[0]._id,
								Provider: result.data.provider,
								platform: "web",
								connectionType: "4g",
							},
							server: result.data.servers[0],
							buttonDisabled: false,
							showIndicators: false,
							showStart: true,
							showRestart: false,
							showToast: false,
							loading: false,
						});

						this.checkServers(result.data.servers)

						if (this.state.session.locationGPS !== 1) {
							this.defaultCenter = result.data.position;
							this.setState({
								session: {
									...this.state.session,
									locationLatitude: result.data.position[0],
									locationLongitude: result.data.position[1],
								},
								center: result.data.position,
								mapCenter: result.data.position,
							});
						}

						var bwmeter = document.querySelector('#bwmeter');
						bwmeter.setAttribute("style", "height:"+bwmeter.offsetHeight+"px");

						if(window.location.hash === "#run") {
							this.handleClick();
						}
					} else this.showError(result);
				},
				(error) => this.showError(error)
			);
	}

	checkServers(servers) {
		var pings = [];

		var pingFinish = function(server, speedometer, pingT) {
			// console.log(server.name + '. Ping finish ' + String(pingT) + ' ms');

			pings.push({
				server: server,
				ping: pingT
			});

			if (pings.length >= servers.length) {
				pings.sort(function(a, b) {
					return (a.ping * a.server.ratio) - (b.ping * b.server.ratio);
				});

				var bestPing = false;
				pings.forEach(ping => {
					if (ping.ping >= 0) {
						bestPing = ping;
						return true;
					}
				});

				pings.some(function(ping) {
					if (ping.ping >= 0) {
						bestPing = ping;
						return true;
					}
					return false;
				});
				// console.log(bestPing)

				if (bestPing !== false) {
					speedometer.setState({
						session: {
							...speedometer.state.session,
							serverID: bestPing.server._id,
						},
						server: bestPing.server,
					});
				}
			}
		}

		var doPing = function(server, speedometer, pings, pingT) {
			if (pings <= 0) {
				pingFinish(server, speedometer, pingT)
			} else {
				Ping(server.url).then(function(delta) {
					if ((delta > 0 && delta < pingT) || pingT === -1) pingT = delta;
					doPing(server, speedometer, pings - 1, pingT);
				}).catch(function(err) {
					doPing(server, speedometer, pings - 1, pingT);
				});
			}
		}

		servers.forEach(server => doPing(server, this, 5, -1));
	}

	checkConnection() {
		this.setState({showToast: false});
		this.reset();
		this.servers();
	}

	reset() {
		this.setState({
			speedometerValue: 0,
			buttonDisabled: true,
			progress: {
				visible: false,
			},
			testStatus: 0,
			ping: "—",
			jitter: "—",
			losses: "—",
			download: "—",
			upload: "—",
			downloadState: false,
			uploadState: false,
			showMapDialog: false,
			my: false,
			features: [],
			speedtests: [],
			detailData: false,
			clusterData: false,
			showDetailPanel: false,
			showClusterPanel: false,
			detail: [],
			stack: false,
			showMy: false,
			address: "",
		});
	}

	showError(error) {
		this.reset();
		console.log("Error", error);
		if (this.state.showToast === false)
			this.setState({showToast: true});
	}

	componentDidMount() {
		this.gps();
		this.servers();

		window.addEventListener('resize', () => {
			var bwmeter = document.querySelector('#bwmeter');
			bwmeter.removeAttribute("style");
			bwmeter.setAttribute("style", "height:"+bwmeter.offsetHeight+"px");
		});

		var megabitus = this;
		$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
			if ($(e.target).attr("id") === "bwmeter-map-tab") {
				megabitus.map.container.fitToViewport();
				megabitus.getSpeedtests(megabitus.state.testIdTemp, megabitus.state.center);
				megabitus.gps();
			} else {
				megabitus.setState({
					addressCardOpened: false,
					showClusterPanel: false,
					showDetailPanel: false,
				});
				var bwmeter = document.querySelector('#bwmeter');
				bwmeter.style.height = bwmeter.offsetHeight+'px';
			}
		});
	}

	handleApiAvaliable(ymaps) {
		this.ymaps = ymaps;
		this.map.behaviors.disable('scrollZoom');

		this.setState({
			ymapsLoaded: true,
		});
	}

	handleCenter() {
		if (this.map.getZoom() !== 15)
			this.map.setZoom(15);

		this.handleCloseAddressCard();
		this.setState({
			mapCenter: this.defaultCenter.slice()
		});
	}

	getSpeedtests(id, position) {
		fetch("https://api.megabitus.com/v1/speedtests"+(id.length > 0 && id !== false ? "?id="+id : (position.length > 0 ? "?position="+position.join(",") : "")), { method: "GET" })
			.then(res => res.json())
			.then(
				(result) => {
					if (result.success) {
						console.log(result);

						this.my = result.data.my;
						this.radius = result.data.radius;

						if (result.data.my) {
							this.defaultCenter = [result.data.my.LocationLat, result.data.my.LocationLng];
							this.setState({
								center: [result.data.my.LocationLat, result.data.my.LocationLng],
								mapCenter: [result.data.my.LocationLat, result.data.my.LocationLng],
							});
						}

						this.setState({
							my: false,
							speedtests: result.data.speedtests,
						});

						this.showPlacemarks(result.data.speedtests, result.data.my, result.data.radius);

					} else {
						this.showError(result);
					}
				},
				(error) => {
					this.showError(error);
				}
			);
	}

	showPlacemarks(speedtests, my, radius) {
		if (my) {
			var speedtest = my;

			var myPlacemark = (
				<>
					<Placemark
						geometry={[speedtest.LocationLat, speedtest.LocationLng]}
						options={{
							iconLayout: 'default#image',
							iconImageHref: '/i/pin-blue.svg',
							iconImageOffset: [-17, -32],
						}}
						onClick={() => {
							this.handleOpenDetail(1, [], false, true);
						}}
					/>
					<Circle
						geometry={[[speedtest.LocationLat, speedtest.LocationLng], radius]}
						options={{
							fillColor: '#ebcb2d',
							fillOpacity: 0.1,
							strokeOpacity: 0.4,
						}}
					/>
				</>
			);

			this.setState({
				my: myPlacemark,
			});
		}

		var features = speedtests.map(
			(speedtest, index) => {
				return {
					type: 'Feature',
					id: index + 1,
					geometry: { type: 'Point', coordinates: [speedtest.LocationLat1, speedtest.LocationLng1] },
					properties: {
						clusterCaption: speedtest.LocationUserName,
						clusterDescription: '<span class="operator-name" title="'+ConnectionTypeString(speedtest, 2)+'">'+ConnectionTypeString(speedtest, 2)+'</span><span class="operator-type">'+ConnectionTypeString(speedtest, 3)+'</span>'
					},
					options: {
						iconLayout: 'default#image',
						iconImageHref: (my ? (my.Download > speedtest.Download && my.Upload > speedtest.Upload ? '/i/pin-red.svg' : (my.Download < speedtest.Download && my.Upload < speedtest.Upload ? '/i/pin-green.svg' : '/i/pin-yellow.svg')) : '/i/pin-green.svg'),
						iconImageOffset: [-17, -32]
					}
				};
			}
		)

		this.setState({
			features: features,
		});
	}

	handleOpenDetail(id, objects, stack, my, coord = [], offset = true) {
		console.log("handleOpenDetail", id, objects, stack, my, coord, offset)

		var pixelCenter, geoCenter;
		var horizontalAspect = offset ? this.refs.addresscard.offsetWidth/2 : 0;

		if (id > 0 || objects.length > 0) {
			if (id > 0) {
				this.setState({
					mapCenter: my ? [this.my.LocationLat1, this.my.LocationLng1] : [this.state.speedtests[id-1].LocationLat1, this.state.speedtests[id-1].LocationLng1],
				});

				pixelCenter = this.map.getGlobalPixelCenter();
				pixelCenter = [pixelCenter[0] + horizontalAspect, pixelCenter[1]];
				geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, this.map.getZoom());

				this.setState({
					mapCenter: geoCenter
				});

				this.setState({
					addressCardOpened: true,
					showClusterPanel: stack ? true : false,
					showDetailPanel: true,
					detailData: my ? this.my : this.state.speedtests[id-1],
					detail: [],
					loadingDetail: true,
					stack: stack,
					showMy: false,
					address: "",
				});

				this.getDetail(my ? this.my.LocationUserID : this.state.speedtests[id-1].LocationUserID);
			}

			if (objects.length > 0) {
				this.setState({
					mapCenter: coord
				});

				pixelCenter = this.map.getGlobalPixelCenter();
				pixelCenter = [pixelCenter[0] + horizontalAspect, pixelCenter[1]];
				geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, this.map.getZoom());

				this.setState({
					mapCenter: geoCenter
				});

				this.setState({
					addressCardOpened: true,
					showClusterPanel: true,
					showDetailPanel: false,
					clusterData: objects,
					detailData: false,
					detail: [],
					stack: false,
					showMy: false,
					address: "",
				});
			}
		} else {
			this.setState({
				mapCenter: this.defaultCenter
			});

			pixelCenter = this.map.getGlobalPixelCenter();
			pixelCenter = [pixelCenter[0] + horizontalAspect, pixelCenter[1]];
			geoCenter = this.map.options.get('projection').fromGlobalPixels(pixelCenter, this.map.getZoom());

			this.setState({
				mapCenter: geoCenter
			});

			this.showAddress(this.defaultCenter);
			this.setState({
				addressCardOpened: true,
				showClusterPanel: false,
				showDetailPanel: true,
				detailData: false,
				detail: [],
				stack: false,
				showMy: true,
				address: "",
				loadingDetail: false,
			});
		}
	}

	handleBack(e) {
		e.preventDefault();

		this.setState({
			showClusterPanel: true,
			showDetailPanel: false,
		});
	}

	renderDetail(speedtest, stack) {
		if (speedtest !== false) {
			return (
				<>
					<div className="map-dialog__card__title">{stack ? (<span className="title__icon" onClick={this.handleBack} dangerouslySetInnerHTML={{__html: '<svg><use xlink:href="/i/i.svg#back"></use></svg>'}}></span>) : ""}{speedtest.LocationUserType > 2 ? speedtest.LocationUserName : speedtest.LocationFullAddress}</div>
					<div className="map-dialog__card__body">
						{speedtest.LocationUserType > 2 ? (<div className="address-label">{speedtest.LocationFullAddress}</div>) : ""}
						<div className="address-coords">{Math.round(speedtest.LocationLat1 * 1000000) / 1000000}, {Math.round(speedtest.LocationLng1 * 1000000) / 1000000}</div>
						{this.buildMarkup(this.state.detail)}
					</div>
				</>
			);
		} else
			return '';
	}

	renderCluster(clusterData) {
		if (clusterData.length > 0) {
			return (
				<>
					<div className="map-dialog__card__title">Список</div>
					<div className="map-dialog__card__body">
						<ul className="map-dialog__card__list">
							{clusterData.map(
								(feature, index) => {
									return (
										<li className="list-item" key={index} onClick={(e) => { e.preventDefault(); this.handleOpenDetail(feature.id, [], true, false, [], false); }}>
											<span className="list-item__label">{feature.properties.clusterCaption}</span><span className="list-item__note">{ReactHtmlParser(feature.properties.clusterDescription)}</span>
										</li>
									);
								}
							)}
						</ul>
					</div>
				</>
			);
		} else
			return '';
	}

	showAddress(position) {
		if (this.ymaps !== null)
			this.ymaps.geocode(position).then(res => {
				let firstGeoObject = res.geoObjects.get(0);

				this.setState((state, props) => ({
					address: firstGeoObject.getAddressLine(),
				}));
			});
	}

	renderMy(show) {
		if (show) {
			return (
				<>
					<div className="map-dialog__card__title">{this.state.address}</div>
					<div className="map-dialog__card__body">
						<div className="address-coords">{Math.round(this.defaultCenter[0] * 1000000) / 1000000}, {Math.round(this.defaultCenter[1] * 1000000) / 1000000}</div>
					</div>
				</>
			);
		}
	}

	getDetail(id) {
		fetch("https://api.megabitus.com/v1/detail?id="+id+(this.my !== null ? "&my="+this.my.TestID : ""), { method: "GET" })
			.then(res => res.json())
			.then(
				(result) => {
					if (result.success) {
						this.setState({
							detail: result.data.detail,
							loadingDetail: false,
						});
					} else {
						this.setState({
							loadingDetail: false,
						});
						console.log(result);
						this.handleDialogClose();
					}
				},
				(error) => {
					this.setState({
						loadingDetail: false,
					});
					console.log(error);
					this.handleDialogClose();
				}
			);
	}

	buildMarkup(markup) {
		if (Array.isArray(markup)) {
			return markup.map(
				(card, index) => {
					if (card instanceof Object) {

						var color;

						if (this.my !== null && card.dtype === 'download')
							color = (this.my.Download > parseFloat(card.dvalue) ? "red" : (this.my.Download < parseFloat(card.dvalue) ? "green" : "default"));

						if (this.my !== null && card.dtype === 'upload')
							color = (this.my.Upload > parseFloat(card.dvalue) ? "red" : (this.my.Upload < parseFloat(card.dvalue) ? "green" : "default"));

						const MarkupTag = `${card.node}`;
						return (
							<MarkupTag key={index} src={card.src} class={((card.class ? card.class : "")+(color ? " "+color : "")).trim()} slot={card.slot} lines={card.lines}>
								{this.buildMarkup(card.content)}
							</MarkupTag>
						);
					} else
						return ReactHtmlParser(card);
				}
			);
		} else
			return ReactHtmlParser(markup);
	}

	render() {
		return (
			<>
			{this.state.showToast ? (
				<div className="bwmeter__error container">
					<div className="bwmeter__error__text">Не удалось установить соединение с сервером</div>
					<button className="btn btn-refresh btn-megabitus btn-megabitus-lg" onClick={() => this.checkConnection()}>Обновить</button>
				</div>
			) : (
				<>
					<div className="nav-pills-wrap d-none">
						<ul className="nav nav-pills" id="bwmeterTab" role="tablist">
							<li className="nav-item"><a className="nav-link active" id="bwmeter-start-tab" data-toggle="tab" href="#bwmeter-start" role="tab" aria-controls="bwmeter-start" aria-selected="true">Скорость</a></li>
							<li className="nav-item"><a className="nav-link" id="bwmeter-map-tab" data-toggle="tab" href="#bwmeter-map" role="tab" aria-controls="bwmeter-map" aria-selected="false">Карта</a></li>
						</ul>
					</div>

					<div className={"tab-content"+(this.state.loading ? " loading" : "")} id="bwmeterTabContent">
						<div className="tab-pane tab-start fade show active" id="bwmeter-start" role="tabpanel" aria-labelledby="bwmeter-start-tab">
							<div className="nav-pills-wrap">
								<ul className="nav nav-pills">
									<li className="nav-item"><a className="nav-link active" href="#bwmeter-start" role="tab" aria-selected="true" onClick={(e) => e.preventDefault()}>Скорость</a></li>
									<li className="nav-item"><a className="nav-link" href="#bwmeter-map" role="tab" aria-selected="false" onClick={(e) => { e.preventDefault(); $('#bwmeterTab li:last-child a').tab('show') }}>Карта</a></li>
								</ul>
							</div>
							<div className="container">
								<div className="bwmeter__header row">
									<div className="bwmeter__header__title col-sm-4">Текущие настройки</div>
									<div className="bwmeter__header__data col-sm-8">
										<div className="row">
											<div className="title col-sm-3 col-md-2">Провайдер</div>
											<div className="data col-sm-9 col-md-8">{this.state.session.Provider ? this.state.session.Provider : '\u00A0'}</div>
										</div>
										<div className="row">
											<div className="title col-sm-3 col-md-2">Сервер</div>
											<div className="data col-sm-9 col-md-8">{this.state.server.name ? this.state.server.name + ", " + this.state.server.provider : '\u00A0'}</div>
										</div>
										<div className={"row last share"+(this.my !== null && !this.state.progress.visible ? " open" : "")}>
											<div className="title col-sm-3 col-md-2">Поделиться</div>
											<div className="data col-sm-9 col-md-8">
												<YandexShare
													content={{
														title: 'Megabitus: '+(this.my ? this.my.LocationUserName : ""),
														url: 'https://www.megabitus.com/result/'+(this.my ? this.my.TestID : "")
													}}
													theme={{
														services: 'vkontakte,facebook,odnoklassniki,twitter,telegram'
													}}
												/>
											</div>
										</div>
									</div>
								</div>

								{this.state.showIndicators ? (
								<div className="bwmeter__body row">
									<div className="bwmeter__body__canvas col-lg-4 col-md-5 col-sm-12">
										<div className="runman">
											<Runman speed={this.state.speedometerValue} download={this.state.downloadState} running={this.state.progress.visible} />
										</div>
										<div className="waves">
											<Waves speed={this.state.speedometerValue} download={this.state.downloadState} running={this.state.progress.visible} />
										</div>
									</div>
									<div className="bwmeter__body__indicators indicators col-lg-8 col-md-7 col-sm-12">
										<div className="row row1">
											<div className="col-md-2 col-sm-12"></div>
											<div className="col-md-4 col-sm-6">
												<div className="indicator-name">Download, Мбит/с</div>
												<div className="indicator-value download">{this.state.download}</div>
											</div>
											<div className="col-md-4 col-sm-6">
												<div className="indicator-name">Upload, Мбит/с</div>
												<div className="indicator-value upload">{this.state.upload}</div>
											</div>
										</div>
										<div className="row row2">
											<div className="col-md-2 col-sm-12"></div>
											<div className="col-md-3 col-sm-4">
												<div className="indicator-name">Ping, мс</div>
												<div className="indicator-value">{this.state.ping}</div>
											</div>
											<div className="col-md-3 col-sm-4">
												<div className="indicator-name">Jitter, мс</div>
												<div className="indicator-value">{this.state.jitter}</div>
											</div>
											<div className="col-md-3 col-sm-4">
												<div className="indicator-name">Потери, %</div>
												<div className="indicator-value">{this.state.losses}</div>
											</div>
										</div>
									</div>
								</div>
								) : (
								<div className="bwmeter__body row">
									<div className="bwmeter__body__canvas col-sm-12">
										<div className="runman">
											<Runman speed={this.state.speedometerValue} download={this.state.downloadState} running={this.state.progress.visible} />
										</div>
									</div>
								</div>
								)}

								{this.state.showStart ? (
								<div className="btn-start-wrap">
									<button className="btn btn-start btn-megabitus btn-megabitus-lg" onClick={this.handleClick} disabled={this.state.buttonDisabled}>Начать тестирование</button>
								</div>
								) : ""}
								{this.state.showRestart ? (
								<div className="btn-start-wrap">
									<button className="btn btn-restart btn-megabitus btn-megabitus-lg" onClick={this.handleClick}>Новое тестирование</button>
								</div>
								) : ""}
							</div>
						</div>

						<div className="tab-pane tab-map fade show" id="bwmeter-map" role="tabpanel" aria-labelledby="bwmeter-map-tab">
							<div ref="mapcontainer" className="tab-pane__map map-container">
								<YMaps query={{ lang: "ru_RU", apikey: "6c6b5001-ca25-4dec-ac48-7ea0e3b44308" }}>
									{this.state.center !== false ? (
									<Map
										width="100%"
										height="100%"
										state={{ center: this.state.mapCenter, zoom: 15, yandexMapDisablePoiInteractivity: true }}
										defaultOptions={{ yandexMapDisablePoiInteractivity: true }}
										modules={["geolocation", "geocode"]}
										onLoad={ymaps => this.handleApiAvaliable(ymaps)}
										instanceRef={ref => this.map = ref}
										>
											<ZoomControl options={{ float: 'right' }} />
											{this.state.ymapsLoaded !== false ? (
											<ObjectManager
												options={{
													clusterize: true,
													gridSize: 32,
													geoObjectOpenBalloonOnClick: false,
													clusterOpenBalloonOnClick: false,
													clusterDisableClickZoom: true,
												}}
												objects={{}}
												clusters={{
													preset: 'islands#redClusterIcons',
												}}
												features={this.state.features}
												instanceRef={ref => {
													if (ref) {
														ref.objects.events.add('click', (e) => {
															e.stopImmediatePropagation();
															this.handleOpenDetail(e.get('objectId'), [], false, false);
														})

														ref.clusters.events.add('click', (e) => {
															e.stopImmediatePropagation();
															var cluster = ref.clusters.getById(e.get('objectId')),
																objects = cluster.properties.geoObjects;

															this.handleOpenDetail(0, objects, false, false, cluster.geometry.coordinates);
														})
													}
												}}
											/>
											) : ""}
											{this.state.ymapsLoaded !== false && this.state.my !== false ? this.state.my : (
												<>
													<Placemark
														geometry={this.state.center}
														defaultOptions={{
															iconLayout: 'default#image',
															iconImageHref: '/i/pin-blue.svg',
															iconImageOffset: [-17, -32]
														}}
														onClick={() => {
															this.handleOpenDetail(0, [], false, false);
														}}
													/>
													<Circle
														geometry={[this.state.center, this.radius]}
														options={{
															fillColor: '#ebcb2d',
															fillOpacity: 0.1,
															strokeOpacity: 0.4,
														}}
													/>
												</>
											)}
									</Map>
									) : ""}
								</YMaps>
							</div>

							<div className="nav-pills-wrap">
								<ul className="nav nav-pills">
									<li className="nav-item"><a className="nav-link" href="#bwmeter-start" role="tab" aria-selected="false" onClick={(e) => { e.preventDefault(); $('#bwmeterTab li:first-child a').tab('show'); }}>Скорость</a></li>
									<li className="nav-item"><a className="nav-link active" href="#bwmeter-map" role="tab" aria-selected="true" onClick={(e) => e.preventDefault()}>Карта</a></li>
								</ul>
							</div>

							<div ref="addresscard" className={"map-dialog__card"+(this.state.addressCardOpened ? " opened" : "")}>
								<span className="map-dialog__card__close" onClick={this.handleCloseAddressCard} dangerouslySetInnerHTML={{__html: '<svg><use xlink:href="/i/i.svg#close"></use></svg>'}}></span>
								<div className="map-dialog__card__block-wrap">
									<div className={"map-dialog__card__block block-cluster"+(this.state.showClusterPanel ? " opened" : "")}>
										{this.renderCluster(this.state.clusterData)}
									</div>
									<div className={"map-dialog__card__block block-detail"+(this.state.showDetailPanel ? " opened" : "")+(this.state.loadingDetail ? " loading" : "")}>
										{this.renderDetail(this.state.detailData, this.state.stack)}
										{this.renderMy(this.state.showMy)}
									</div>
								</div>
								{this.my !== null ? (
								<div className="map-dialog__card__footer">
									<div className="indicators">
										<div className="row row0">
											<div className="col col-label">
												{ConnectionTypeString(this.my, 2)}{this.my.ConnectionType === 'wifi' ? (<><br /><small>{this.my.Provider}</small></>) : ""}
												<div className="code text-muted">#{this.my.TestID}</div>
											</div>
											<div className="col col-note">
												{ConnectionTypeString(this.my, 3)}
											</div>
										</div>
										<div className="row row3">
											<div className="col-sm-12">
												<YandexShare
													content={{
														title: 'Megabitus: '+this.my.LocationUserName,
														url: 'https://www.megabitus.com/result/'+this.my.TestID
													}}
													theme={{
														size: 's',
														services: 'vkontakte,facebook,odnoklassniki,twitter,telegram'
													}}
												/>
											</div>
										</div>
										<div className="row row1">
											<div className="col-sm-6">
												<div className="indicator-name">Download, Мбит/с</div>
												<div className="indicator-value download">{this.my.Download.toFixed(2)}</div>
											</div>
											<div className="col-sm-6">
												<div className="indicator-name">Upload, Мбит/с</div>
												<div className="indicator-value upload">{this.my.Upload.toFixed(2)}</div>
											</div>
										</div>
										<div className="row row2">
											<div className="col-sm-4">
												<div className="indicator-name">Ping, мс</div>
												<div className="indicator-value">{this.my.Ping.toFixed(2)}</div>
											</div>
											<div className="col-sm-4">
												<div className="indicator-name">Jitter, мс</div>
												<div className="indicator-value">{this.my.Jitter.toFixed(2)}</div>
											</div>
											<div className="col-sm-4">
												<div className="indicator-name">Потери, %</div>
												<div className="indicator-value">{this.my.Losses.toFixed(2)}</div>
											</div>
										</div>
									</div>
								</div>
								) : ""}
							</div>

							<div className="tab-pane__center map-center" onClick={() => {this.handleCenter(); }} dangerouslySetInnerHTML={{__html: '<svg><use xlink:href="/i/i.svg#geocontrol"></use></svg>'}}></div>
						</div>
					</div>

					{this.state.session.locationLatitude && this.state.session.locationLongitude && this.state.GPSEnd && this.state.showMapDialog ? (
						<MapDialog
							show={this.state.showMapDialog}
							onClose={this.handleCloseMapDialog}
							onMap={this.handleOpenMap}
							onRestart={this.handleRestartMapDialog}
							id={this.state.testIdTemp}
							indicators={{ping: this.state.ping, jitter: this.state.jitter, losses: this.state.losses, download: this.state.download, upload: this.state.upload, provider: this.state.session.Provider, type: "LAN"}}
							position={[this.state.session.locationLatitude, this.state.session.locationLongitude]}
						/>
					) : ""}

					<Poll
						poll={this.state.poll}
						timeout={this.state.pollTimeout}
					/>
				</>
			)}
			</>
		);
	}
}

ReactDOM.render(<Megabitus />, document.querySelector('#bwmeter'));
